module.exports = __webpack_public_path__ + "img/logo.6d63aa5a.png";